import { useMemo } from "react";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { HistoryDetailsItem } from "@common/types/auditLog";
import { APIProcessName } from "@common/constants/process-names";
import splitDrawerStyles from "../split/SplitHistoryDrawer.module.scss";
import {
    HistoryInvoiceTemplateChangeDetails,
    HistoryInvoiceTemplateContentDetails,
} from "../HistoryInvoiceTemplateDetails";
import {
    buildInvoiceTemplateChangeRow,
    buildInvoiceTemplateContentRow,
} from "./utils/historyInvoiceTemplateDetailsRows";

interface HistoryInvoiceTemplateDrawerContentProps {
    logs: HistoryDetailsItem[];
    sourceType: string;
    isError: boolean;
    onRetry: () => void;
    footer: React.ReactNode;
}

export const HistoryInvoiceTemplateDrawerContent: React.FC<
    HistoryInvoiceTemplateDrawerContentProps
> = ({ logs, sourceType, isError, onRetry, footer }) => {
    const changeRows = useMemo(
        () => logs.map(buildInvoiceTemplateChangeRow),
        [logs],
    );
    const contentRows = useMemo(
        () => logs.map(buildInvoiceTemplateContentRow),
        [logs],
    );

    if (isError) {
        return (
            <div className={splitDrawerStyles.emptyContainer}>
                <EmptyState
                    header="Failed to load invoice template changes"
                    ctaText="Retry"
                    action={onRetry}
                />
            </div>
        );
    }

    if (logs.length === 0) {
        return (
            <div className={splitDrawerStyles.emptyContainer}>
                <EmptyState header="No invoice template changes found" />
            </div>
        );
    }

    if (sourceType === APIProcessName.INVOICE_TEMPLATE_UPDATE_CONTENT) {
        return (
            <HistoryInvoiceTemplateContentDetails
                data={contentRows}
                footer={footer}
            />
        );
    }

    return (
        <HistoryInvoiceTemplateChangeDetails
            data={changeRows}
            footer={footer}
        />
    );
};
